import React from "react";
import { t } from "../../../components/CustomComponent.js";
import ICON from "../icons.js";

/* ============================================================================
 * HomePartner — แถบชวนสมัครเป็นพาร์ตเนอร์ในหน้าแรก
 *
 * วางไว้หลังบล็อก "จุดเด่น + ตัวเลข" (HomeAbout) เพราะคนที่เพิ่งอ่านว่าเรามีทรัพย์
 * และลูกค้าเท่าไร คือคนที่พร้อมสนใจร่วมงานมากที่สุด — วางไว้บนสุดจะแย่งสายตา
 * ผู้ซื้อ/ผู้เช่าซึ่งเป็นผู้ใช้หลักของหน้าแรก
 *
 * เป็นแค่ทางเข้า ไม่ได้กรอกอะไรตรงนี้ — กดแล้วไปหน้า /partner ที่มีฟอร์มจริง
 * ========================================================================== */
const POINTS = [
  { key: "partner_home_point_1", icon: ICON.money },
  { key: "partner_home_point_2", icon: ICON.building },
  { key: "partner_home_point_3", icon: ICON.headset },
];

export default function HomePartner({ onApply }) {
  return (
    <div className="hm-container">
      <section className="hm-partner" id="hm-partner">
        <div className="hm-partner__text">
          <span className="hm-partner__kicker">
            <span className="hm-ico">{ICON.handshake}</span>
            {t("partner_kicker")}
          </span>
          <h2 className="hm-partner__title">{t("partner_home_title")}</h2>
          <p className="hm-partner__desc">{t("partner_home_desc")}</p>

          <ul className="hm-partner__points">
            {POINTS.map((item) => (
              <li key={item.key}>
                <span className="hm-ico">{item.icon}</span>
                {t(item.key)}
              </li>
            ))}
          </ul>
        </div>

        <div className="hm-partner__action">
          <button type="button" className="hm-btn hm-btn--primary" onClick={onApply}>
            <span className="hm-ico">{ICON.user}</span>
            {t("partner_cta")}
          </button>
          <span className="hm-partner__note">{t("partner_home_note")}</span>
        </div>
      </section>
    </div>
  );
}
